import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './LoginPage.css';
import VERSION from '../version';

export default function CadastroPage() {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ nomeGrupo: '', nome: '', username: '', password: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  function set(k, v) { setForm(p => ({ ...p, [k]: v })); }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!form.nomeGrupo.trim()) { setError('Informe o nome do seu grupo.'); return; }
    if (!form.nome.trim()) { setError('Informe seu nome completo.'); return; }
    if (!form.username.trim()) { setError('Informe um nome de usuário.'); return; }
    if (form.username.includes(' ')) { setError('O usuário não pode ter espaços.'); return; }
    if (form.password.length < 6) { setError('A senha deve ter pelo menos 6 caracteres.'); return; }
    if (form.password !== form.confirm) { setError('As senhas não coincidem.'); return; }

    setLoading(true);
    try {
      const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
      const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

      // 1. Criar grupo primeiro
      const { data: grupo, error: grupoError } = await supabase
        .from('grupos')
        .insert({ nome: form.nomeGrupo.trim(), plano: 'free', max_usuarios: 3 })
        .select().single();

      if (grupoError) {
        setError('Erro ao criar grupo. Tente novamente.');
        setLoading(false);
        return;
      }

      // 2. Usar Edge Function para criar usuário (sem rate limit de email)
      const res = await fetch(`${supabaseUrl}/functions/v1/create-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': anonKey,
          'Authorization': `Bearer ${anonKey}`,
        },
        body: JSON.stringify({
          action: 'create',
          username: form.username.trim().toLowerCase(),
          password: form.password,
          name: form.nome.trim(),
          role: 'admin',
          grupo_id: grupo.id,
          must_change_password: false,
        }),
      });

      const result = await res.json();

      if (!res.ok) {
        // Remover grupo criado se falhou
        await supabase.from('grupos').delete().eq('id', grupo.id);
        if (result.error?.includes('already registered') || result.error?.includes('already been registered')) {
          setError('Este nome de usuário já está em uso. Escolha outro.');
        } else {
          setError(result.error || 'Erro ao criar conta. Tente novamente.');
        }
        setLoading(false);
        return;
      }

      setStep(2);
    } catch (err) {
      setError('Erro inesperado: ' + err.message);
    }
    setLoading(false);
  }

  if (step === 2) return (
    <div className="login-bg">
      <div className="login-glow" />
      <div className="login-card fade-in" style={{ textAlign:'center' }}>
        <div style={{ fontSize:'3rem', marginBottom:16 }}>🎉</div>
        <h2 style={{ color:'var(--text)', fontWeight:800, marginBottom:8 }}>Conta criada!</h2>
        <p style={{ color:'var(--text2)', fontSize:'0.9rem', marginBottom:24 }}>
          Seu grupo foi criado com sucesso. Faça login para começar.
        </p>
        <button className="btn btn-primary w-full" onClick={() => navigate('/login')}>
          Ir para o Login
        </button>
      </div>
    </div>
  );

  return (
    <div className="login-bg">
      <div className="login-glow" />
      <div className="login-card fade-in">
        <div className="login-logo">
          <span className="login-logo-icon">₿</span>
          <div>
            <h1 className="login-title">Fincasa</h1>
            <p className="login-sub">Criar minha conta</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Nome do Grupo</label>
            <input type="text" placeholder="Ex: Família Silva" value={form.nomeGrupo}
              onChange={e => set('nomeGrupo', e.target.value)} autoFocus maxLength={60} />
            <span style={{ color:'var(--text3)', fontSize:'0.75rem', marginTop:4, display:'block' }}>
              Nome que identifica seu grupo familiar
            </span>
          </div>
          <div className="form-group">
            <label>Seu Nome Completo</label>
            <input type="text" placeholder="Ex: João Silva" value={form.nome}
              onChange={e => set('nome', e.target.value)} maxLength={80} />
          </div>
          <div className="form-group">
            <label>Nome de Usuário</label>
            <input type="text" placeholder="Ex: joaosilva" value={form.username}
              onChange={e => set('username', e.target.value.toLowerCase())}
              autoCapitalize="none" autoCorrect="off" maxLength={30} />
            <span style={{ color:'var(--text3)', fontSize:'0.75rem', marginTop:4, display:'block' }}>
              Sem espaços. Será usado para fazer login.
            </span>
          </div>
          <div className="form-group">
            <label>Senha</label>
            <input type="password" placeholder="Mínimo 6 caracteres" value={form.password}
              onChange={e => set('password', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Confirmar Senha</label>
            <input type="password" placeholder="Repita a senha" value={form.confirm}
              onChange={e => set('confirm', e.target.value)} />
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          <button className="btn btn-primary w-full login-btn" disabled={loading}>
            {loading ? <><span className="spinner" /> Criando conta...</> : 'Criar Minha Conta'}
          </button>
        </form>

        <p className="login-footer">
          Já tem uma conta?{' '}
          <Link to="/login" style={{ color:'var(--accent)' }}>Fazer login</Link>
          <br /><span className="version-badge">v{VERSION}</span>
        </p>
      </div>
    </div>
  );
}
